import { jsx } from "react/jsx-runtime";
import { Pagination as Pagination$1 } from "antd";
import { useTheme } from "./Theme/UI.js";
import "./Theme/themeUtils.js";
import "./Theme/themes.js";
const Pagination = ({
  current = 1,
  pageSize = 10,
  total = 0,
  ...props
}) => {
  const {
    themeSettings: { className }
  } = useTheme();
  return /* @__PURE__ */ jsx(
    Pagination$1,
    {
      className,
      current,
      pageSize,
      total,
      ...props
    }
  );
};
export {
  Pagination as default
};
